/* 1az1 · „rc" szerkesztői oldal — közös viselkedés a 1az1-rc-* section-öknek.
   Egyszer fut le akkor is, ha több section tölti be. */
(function () {
  if (window.__rc1az1) return;
  window.__rc1az1 = true;

  var indit = function () {
    /* ---- Rendelés-gombok → utánvét-űrlap (beágyazott: odagörget; popup: megnyitja) ---- */
    var beagyazott = function () {
      var f = document.querySelector('.es-form-container, .es-form');
      return (f && f.getBoundingClientRect().height > 40) ? f : null;
    };
    document.addEventListener('click', function (e) {
      var g = e.target.closest('.js-rendel');
      if (!g) return;
      var f = beagyazott();
      if (f) {
        e.preventDefault();
        window.scrollTo({ top: f.getBoundingClientRect().top + window.scrollY - 24, behavior: 'smooth' });
        setTimeout(function () {
          var mezo = f.querySelector('input:not([type=hidden])');
          if (mezo) try { mezo.focus({ preventScroll: true }); } catch (_) {}
        }, 700);
        return;
      }
      var trigger = document.getElementById('es-popup-button')
                 || document.querySelector('.es-popup-button, .es-sticky-btn')
                 || document.getElementById('es-sticky');
      if (trigger) { e.preventDefault(); trigger.click(); }
    });

    /* ---- Haladás-jelző ---- */
    var bar = document.querySelector('.rc-page .progress');
    if (bar) {
      var var_ = false;
      var rajzol = function () {
        var_ = false;
        var d = document.documentElement, max = d.scrollHeight - window.innerHeight;
        bar.style.width = (max > 0 ? Math.min(100, Math.max(0, window.scrollY / max * 100)) : 0).toFixed(1) + '%';
      };
      var fr = function () { if (!var_) { var_ = true; requestAnimationFrame(rajzol); } };
      window.addEventListener('scroll', fr, { passive: true });
      window.addEventListener('resize', fr, { passive: true });
      fr();
    }

    /* ---- Videók: csak a képernyőn töltenek és játszanak ---- */
    var vo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }, { rootMargin: '150px 0px', threshold: 0 });
    document.querySelectorAll('.rc-page video[data-src]').forEach(function (v) { vo.observe(v); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) document.querySelectorAll('.rc-page video').forEach(function (v) { v.pause(); });
    });

    /* ---- Galéria: magától lépked, érintésre megáll ---- */
    document.querySelectorAll('.rc-page [data-gal]').forEach(function (g) {
      var main = g.querySelector('.gal-main img'), box = g.querySelector('.gal-main');
      var gombok = [].slice.call(g.querySelectorAll('.gal-thumbs button'));
      if (!main || gombok.length < 2) return;
      var LEPES = 4500, SZUNET = 5000, i = 0, ora = null, ujra = null;
      gombok.forEach(function (b, ix) { if (b.getAttribute('aria-current') === 'true') i = ix; });
      var mutat = function (uj) {
        if (uj === i) return;
        i = uj;
        var kep = gombok[i].getAttribute('data-nagy');
        box.classList.add('valt');
        setTimeout(function () { main.src = kep; box.classList.remove('valt'); }, 180);
        gombok.forEach(function (x, ix) { x.setAttribute('aria-current', ix === i ? 'true' : 'false'); });
      };
      var indul = function () { clearInterval(ora); ora = setInterval(function () { mutat((i + 1) % gombok.length); }, LEPES); };
      var megall = function () { clearInterval(ora); clearTimeout(ujra); ujra = setTimeout(indul, SZUNET); };
      g.querySelector('.gal-thumbs').addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        mutat(gombok.indexOf(b)); megall();
      });
      /* nyilak + ujjal húzás: jobbra-balra lapoz */
      var lep = function (d) { mutat((i + d + gombok.length) % gombok.length); megall(); };
      var el = g.querySelector('[data-gal-elozo]'), kov = g.querySelector('[data-gal-kov]');
      if (el) el.addEventListener('click', function (e) { e.stopPropagation(); lep(-1); });
      if (kov) kov.addEventListener('click', function (e) { e.stopPropagation(); lep(1); });
      var x0 = null, y0 = null;
      box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; megall(); }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) lep(dx < 0 ? 1 : -1);
        x0 = null;
      }, { passive: true });
      box.addEventListener('click', megall);
      if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) indul(); else clearInterval(ora); }, { threshold: .25 }).observe(box);
    });

    /* ---- Valós sürgetés: a nap állásához igazodik ---- */
    var cut = document.querySelector('.rc-page [data-cutoff]');
    var CUTOFF = cut ? parseInt(cut.getAttribute('data-cutoff'), 10) || 15 : 15;
    var now = new Date(), nap = now.getDay(), ora_ = now.getHours();
    var mic = window.matchMedia('(max-width:640px)').matches;
    var sav = '', urg = '';
    if (nap === 0 || nap === 6) {
      sav = mic ? 'Comenzile din weekend pleacă luni' : 'Comenzile din weekend pleacă luni dimineață cu curierul';
      urg = '<b>Comandă acum</b> și pleacă luni dimineață.';
    } else if (ora_ < CUTOFF) {
      var m = CUTOFF * 60 - (ora_ * 60 + now.getMinutes()), hh = Math.floor(m / 60), mm = m % 60;
      sav = mic ? 'Comandă până la ' + CUTOFF + ':00 → pleacă azi' : 'Comenzile plasate până azi la ' + CUTOFF + ':00 pleacă azi cu curierul';
      urg = 'Mai ai <b>' + (hh ? hh + 'h ' : '') + mm + ' min</b> ca să prinzi curierul de azi.';
    } else {
      sav = mic ? 'Comenzile de azi pleacă mâine' : 'Comenzile de azi pleacă mâine dimineață cu curierul';
      urg = '<b>Comandă acum</b> — coletul pleacă mâine dimineață.';
    }
    document.querySelectorAll('.rc-page [data-cutoff-sav]').forEach(function (el) { el.textContent = sav; });
    document.querySelectorAll('.rc-page [data-cutoff-urg]').forEach(function (el) { el.innerHTML = urg; });

    /* ---- Ragadós sáv: akkor jön elő, ha a hero gombja már nem látszik ---- */
    var st = document.querySelector('.rc-page .sticky');
    var heroBtn = document.querySelector('.rc-page .hero .btn') || document.querySelector('.rc-page .hero');
    if (st) {
      var latszik = !!heroBtn;
      var fr2 = function () { st.classList.toggle('on', !latszik && window.scrollY > 220); };
      if (heroBtn) new IntersectionObserver(function (es) { latszik = es[0].isIntersecting; fr2(); }, { threshold: 0 }).observe(heroBtn);
      window.addEventListener('scroll', fr2, { passive: true });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indit);
  else indit();
})();
